import React, { useEffect, useState } from "react";
import interiorLibraryAdminApi from "../services/interiorLibraryAdminApi";
import { useNavigate } from "react-router-dom";

export default function InteriorMaterialLibraryPage() {
    const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [form, setForm] = useState({
    material_key: "",
    name: "",
    category: "",
  });

  async function load() {
    const [matRes, catRes] = await Promise.all([
      interiorLibraryAdminApi.listMaterials(),
      interiorLibraryAdminApi.listCategories({ scope: "material" }),
    ]);

    setItems(matRes.items || []);
    setCategories(catRes.items || []);
  }

  useEffect(() => {
    load();
  }, []);

  async function create() {
    if (!form.material_key || !form.name || !form.category) {
      alert("Fill all fields.");
      return;
    }

   const res = await interiorLibraryAdminApi.createMaterial(form);
const id = res?.item?.id;

if (id) {
  navigate(`/interior-editor/materials/${id}`);
  return;
}

setForm({ material_key: "", name: "", category: "" });
await load();
  }

  async function remove(id) {
    if (!window.confirm("Delete material?")) return;
    await interiorLibraryAdminApi.deleteMaterial(id);
    await load();
  }

  return (
    <div className="p-4 space-y-4 bg-slate-50 min-h-screen">
      <h1 className="text-xl font-semibold">Materials</h1>

      {/* CREATE */}
      <div className="bg-white border p-3 rounded space-y-2">
        <input
          placeholder="material_key"
          value={form.material_key}
          onChange={(e) => setForm(p => ({ ...p, material_key: e.target.value }))}
          className="w-full px-2 py-1 border rounded"
        />

        <input
          placeholder="Name"
          value={form.name}
          onChange={(e) => setForm(p => ({ ...p, name: e.target.value }))}
          className="w-full px-2 py-1 border rounded"
        />

        <select
          value={form.category}
          onChange={(e) => setForm(p => ({ ...p, category: e.target.value }))}
          className="w-full px-2 py-1 border rounded"
        >
          <option value="">Select category</option>
          {categories.map(c => (
            <option key={c.id} value={c.category_key}>
              {c.label}
            </option>
          ))}
        </select>

        <button
          onClick={create}
          className="px-3 py-1 bg-blue-600 text-white rounded"
        >
          Create
        </button>
      </div>

      {/* LIST */}
      <div className="bg-white border rounded">
        <table className="w-full text-sm">
          <thead className="bg-slate-100">
            <tr>
              <th className="p-2 text-left">Key</th>
              <th className="p-2 text-left">Name</th>
              <th className="p-2 text-left">Category</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items.map(m => (
              <tr key={m.id} className="border-t">
                <td className="p-2">{m.material_key}</td>
                <td className="p-2">{m.name}</td>
                <td className="p-2">{m.category}</td>
                <td className="p-2">
  <div className="flex gap-2">
    <button
      onClick={() => navigate(`/interior-editor/materials/${m.id}`)}
      className="px-2 py-1 border rounded text-blue-600"
    >
      Open / Edit
    </button>

    <button
      onClick={() => remove(m.id)}
      className="px-2 py-1 border rounded text-red-600"
    >
      Delete
    </button>
  </div>
</td>
              </tr>
            ))}

            {!items.length && (
              <tr>
                <td colSpan="4" className="p-3 text-slate-400">
                  No materials
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}